import { getPurchaseDetailsEndpoint } from '@api/fetchers/checkout';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import {
  getIsSubscribedToGoal,
  getIsSubscribedToIconic,
  getIsSubscribedToIconicPro
} from '@api/selectors/subscription';
import { subscriptionTypes } from '@constants/index';
import { emptyList } from '@constants/empty';
import useFetch from '@hooks/useFetch';

const useReferralCodeSuggestions = (subscriptionUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const { data: purchaseDetails } = useFetch(
    subscriptionUID ? getPurchaseDetailsEndpoint(subscriptionUID) : null
  );

  const goalUID = purchaseDetails?.subscription?.goal?.uid || null;
  const subscriptionType = purchaseDetails?.subscription?.type;

  const isIconicPlan = subscriptionType === subscriptionTypes.ICONIC;
  const isIconicProPlan = subscriptionType === subscriptionTypes.ICONIC_PRO;

  const isExtendPlan = useMyInfo(getIsSubscribedToGoal(goalUID));
  const isSubscribedToIconic = useMyInfo(getIsSubscribedToIconic(goalUID));
  const isSubscribedToIconicPro = useMyInfo(
    getIsSubscribedToIconicPro(goalUID)
  );

  // Plus → Iconic / Iconic Pro: user has Plus only (not already on a higher tier).
  const isPlusTierUpgrade =
    isExtendPlan &&
    !isSubscribedToIconic &&
    !isSubscribedToIconicPro &&
    (isIconicPlan || isIconicProPlan);

  // Iconic → Iconic Pro: user has Iconic but not Iconic Pro yet.
  const isIconicToIconicProUpgrade =
    isSubscribedToIconic && !isSubscribedToIconicPro && isIconicProPlan;

  const isUpgrade = isPlusTierUpgrade || isIconicToIconicProUpgrade;

  const { data: referralCodes, ...rest } = useFetch(
    subscriptionUID && isLoggedIn
      ? `v1/subscriptions/suggest_referral_codes?subscription_uid=${subscriptionUID}&is_extend=${isExtendPlan}&is_upgrade=${isUpgrade}`
      : null
  );

  return { referralCodes: referralCodes || emptyList, ...rest };
};

export default useReferralCodeSuggestions;
